import {
  Separator,
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
  ThemeProvider,
} from "@enduring-systems/react-ui";
import { Outlet } from "react-router-dom";

import { ChatWidget } from "@/features/assistant/components/ChatWidget";

import { AppSidebar } from "./AppSidebar";
import { Breadcrumbs } from "./Breadcrumbs";
import { EnvBadge } from "./EnvBadge";

export function AppLayout(): React.ReactElement {
  return (
    <SidebarProvider>
      <ThemeProvider theme="ops-dark">
        <AppSidebar />
      </ThemeProvider>
      <SidebarInset className="h-svh overflow-hidden">
        <header
          data-testid="app-header"
          className="z-10 flex h-14 shrink-0 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur"
        >
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-1 h-4" />
          <Breadcrumbs />
          <div className="flex-1" />
          <EnvBadge />
        </header>
        <main data-testid="app-main" className="min-h-0 flex-1 overflow-y-auto p-4">
          <Outlet />
        </main>
        <ChatWidget />
      </SidebarInset>
    </SidebarProvider>
  );
}
